export const ACCURACY_COMPARISON_ROWS = [
  {
    feature: "Data Quality",
    Conectify: "Technographics insights & proprietary 3-step verification process",
    zoominfo: "Combination of manually mined and machine-generated data",
  },
  {
    feature: "Data Accuracy",
    Conectify: "Guarantees 85% Data Accuracy on all the data fields",
    zoominfo: "Averages a data accuracy of 80% according to online reviews",
  },
  {
    feature: "Data Ownership",
    Conectify: "Your data remains yours forever",
    zoominfo: "You cannot retain data once you stop renewing your subscription",
  },
  {
    feature: "Contact Quality",
    Conectify: "250M contacts with key decision-makers",
    zoominfo: "Predominantly consists of leads with low decision-making authority",
  },
  {
    feature: "Contact Coverage",
    Conectify: "Global data Coverage across all verticals",
    zoominfo: "Coverage limited to its own database",
  },
  {
    feature: "Pricing",
    Conectify: "All-round access for every plan at a better price",
    zoominfo: "Exorbitant pricing as you add more features",
  },
  {
    feature: "Customer Success",
    Conectify: "Dedicated customer success manager",
    zoominfo: "Only on highest tier enterprise-plus",
  },
];